import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Crown } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function UpgradeModal({
  open, onOpenChange,
  eyebrow = "Free plan · 1 muse",
  title = "Upgrade to Pro for up to 3 muses",
  description = "Run a full roster of muses, each with her own locked identity, sets and offers.",
}) {
  const nav = useNavigate();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white border border-[#F0EAF7] rounded-[20px] shadow-[0_8px_30px_rgba(26,19,37,0.06)] max-w-[92vw] sm:max-w-md p-8 text-center" data-testid="upgrade-modal">
        <div className="mx-auto w-14 h-14 rounded-full flex items-center justify-center mb-4 bg-[#F1E9FE]">
          <Crown className="text-[#9C4DDC]" strokeWidth={1.5} />
        </div>
        <p className="eyebrow">{eyebrow}</p>
        <DialogTitle className="font-display text-3xl font-normal mt-3" data-testid="upgrade-modal-title">{title}</DialogTitle>
        <DialogDescription className="muted text-sm mt-2">{description}</DialogDescription>
        <button className="btn-primary w-full mt-6" onClick={() => { onOpenChange(false); nav("/pricing"); }} data-testid="upgrade-modal-upgrade-button">Upgrade to Pro</button>
        <button className="text-sm muted mt-4 hover:text-[#1A1325] underline-offset-4 hover:underline" onClick={() => onOpenChange(false)} data-testid="upgrade-modal-close-button">Maybe later</button>
      </DialogContent>
    </Dialog>
  );
}

export const CardLimitModal = (props) => (
  <UpgradeModal {...props} eyebrow="Free plan · 3 posts"
    title="You've used your 3 free posts."
    description="Go Pro for unlimited posts, 3 muses and the Weekly Planner." />
);
